module.exports = __webpack_public_path__ + "img/pleisure_bodyimage01.184e378a.jpg";